"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nfid = void 0;
const tslib_1 = require("tslib");
const rxjs_1 = require("rxjs");
const make_iframe_1 = require("./iframe/make-iframe");
const mount_iframe_1 = require("./iframe/mount-iframe");
const nfidBehaviorSubject$ = new rxjs_1.BehaviorSubject({
    isAuthenticated: false,
    isIframeInstantiated: false,
});
nfidBehaviorSubject$.subscribe({
    next(value) {
        console.debug('nfidBehavioorSubject: new state', { value });
    },
    error(err) {
        console.error('nfidBehavioorSubject: something went wrong:', { err });
    },
    complete() {
        console.debug('nfidBehavioorSubject done');
    },
});
exports.nfid = {
    get provider() {
        return nfidBehaviorSubject$.value.provider;
    },
    get ic() {
        return nfidBehaviorSubject$.value.ic;
    },
    get isAuthenticated() {
        return nfidBehaviorSubject$.value.isAuthenticated;
    },
    get isIframeInstantiated() {
        return nfidBehaviorSubject$.value.isIframeInstantiated;
    },
    init({ origin = 'https://nfid.one' }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.debug('NFID.init', { origin });
            console.debug('NFID.init: inpage providers instantiated');
            return new Promise((resolve) => {
                const nfidIframe = (0, make_iframe_1.buildIframe)({
                    origin,
                    onLoad: () => {
                        nfidBehaviorSubject$.next(Object.assign(Object.assign({}, nfidBehaviorSubject$.value), { isIframeInstantiated: true, nfidIframe }));
                        resolve(true);
                    },
                });
            });
        });
    },
    /**
     * @deprecated - use connect() instead
     */
    login() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.connect();
        });
    },
    connect() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!nfidBehaviorSubject$.value.nfidIframe)
                throw new Error('NFID iframe not instantiated');
            (0, mount_iframe_1.showIframe)();
            return new Promise((resolve) => {
                const source = (0, rxjs_1.fromEvent)(window, 'message');
                const events = source.pipe((0, rxjs_1.first)((event) => event.data && event.data.type === 'nfid_authenticated'));
                events.subscribe(() => {
                    console.debug('NFID.connect: authenticated');
                    nfidBehaviorSubject$.next(Object.assign(Object.assign({}, nfidBehaviorSubject$.value), { isAuthenticated: true }));
                    (0, mount_iframe_1.hideIframe)();
                    resolve(true);
                });
            });
        });
    },
    disconnect() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.debug('NFID.disconnect');
        });
    },
};
